import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="mainPage">
      <div className="comingsoon">
        Website for UFC fan!<br />
        We help you find best talent fighting in octagon!
      </div>
      <img src="/mainPoster.png" alt="UFC Bot" style={{ width: '400px' }} />
      <div className="comingsoon">
        Want to know when is your favorite fighter's next bout? Go to <Link to="/fighters" className="fighter-btn">Fighters</Link> section and set notifications!
      </div>
      <div className="comingsoon">
        Very soon you will be able to talk to our UFC Bot!
      </div>
    </div>
  );
};

export default Home; 